import { createFileRoute } from '@tanstack/react-router'
import LegalDocuments from '../components/legal-requirement/LegalDocuments'

export const Route = createFileRoute('/_a/legalDocuments/$requirementId')({
  component: LegalDocuments,
})
